import $api from "@/frontend/shared/api/axios";

type TUpdateOrgDetailsProps = {
  id: number;
  name?: string;
  profilePhotoImgUrl?: string | null;
};

export async function patchUpdateOrgDetails({ id, name, profilePhotoImgUrl }: TUpdateOrgDetailsProps) {
  const response = await $api.patch(`/organizations/${id}`, { name, profilePhotoImgUrl });
  return response.data;
}
